import React from 'react';
import MiddleContent from './MiddleContent';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import StepsBar, { StepsBarProps } from './StepsBar';
import { Theme } from '@material-ui/core/styles';
import Header from './Header';

export const useWrapperStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerStyles: {
            width: '100%',
            '& .logo': {
                marginRight: 51,
                maxHeight: 36,
                [theme.breakpoints.down('xs')]: {
                    height: 24,
                },
            },
            '& .header': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: theme.spacing(4),
                '& .back-label': {
                    color: '#73717F',
                    marginLeft: theme.spacing(3),
                },
                '& .back': {
                    display: 'flex',
                    alignItems: 'center',
                },
                '& .cursor': {
                    cursor: 'pointer',
                },
                '& .hide': {
                    visibility: 'hidden',
                },
                [theme.breakpoints.down('xs')]: {
                    marginTop: 12,
                    marginBottom: 12,
                    '& .back-label': {
                        display: 'none',
                    },
                    '& .logo': {
                        marginRight: 0,
                    },
                },
            },
        },
    }),
);

interface SignupContentWrapperProps {
    heading?: string;
    subHeading?: string;
    stepInfo?: StepsBarProps['stepInfo'];
    showCloseButton?: true;
    backUrl?: string;
    maxWidth?: number;
    children:
        | React.ReactChild
        | React.ReactChild[]
        | React.ReactNode
        | React.ReactNode[];
    disableAnimation?: boolean;
    onBackClick?: () => void;
}

const SignupContentWrapper: React.FC<SignupContentWrapperProps> = ({
    heading,
    stepInfo,
    subHeading,
    backUrl,
    children,
    showCloseButton,
    maxWidth,
    disableAnimation,
    onBackClick,
}) => {
    return (
        <>
            <Header
                backUrl={backUrl}
                showCloseButton={showCloseButton}
                onBackClick={onBackClick}
            />
            <div>
                {stepInfo && <StepsBar stepInfo={stepInfo} />}
                <MiddleContent
                    heading={heading}
                    subHeading={subHeading}
                    maxWidth={maxWidth}
                    disableAnimation={disableAnimation}
                >
                    {children}
                </MiddleContent>
            </div>
        </>
    );
};

export default SignupContentWrapper;
